var map = {
	"./elephant_ui_disappointed": 1072,
	"./elephant_ui_disappointed.svg": 1072,
	"./elephant_ui_greeting": 1069,
	"./elephant_ui_greeting.svg": 1069,
	"./elephant_ui_plane": 1064,
	"./elephant_ui_plane.svg": 1064,
	"./elephant_ui_working": 680,
	"./elephant_ui_working.svg": 680,
	"./friends-cropped": 1073,
	"./friends-cropped.png": 1073,
	"./glitch-preview": 1074,
	"./glitch-preview.jpg": 1074,
	"./logo_warn_glitch": 167,
	"./logo_warn_glitch.svg": 167,
	"./mbstobon-ui-0": 1075,
	"./mbstobon-ui-0.png": 1075,
	"./mbstobon-ui-1": 1076,
	"./mbstobon-ui-1.png": 1076,
	"./mbstobon-ui-2": 1077,
	"./mbstobon-ui-2.png": 1077,
	"./mbstobon-ui-3": 1078,
	"./mbstobon-ui-3.png": 1078,
	"./wave-drawer": 1079,
	"./wave-drawer-glitched": 1080,
	"./wave-drawer-glitched.png": 1080,
	"./wave-drawer.png": 1079
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1118;